import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserApiService} from '../api/user-api.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {passwordMatchValidator} from '../profile/password-validator';
import {ToastrService} from 'ngx-toastr';
import {ChapterApiService} from '../api/chapter-api.service';
import {MembershipType, STATES, UserStatus} from '../constants';
import {SpinnerService} from '../shared/services/spinner.service';
import {finalize} from 'rxjs';
import { FormArray } from '@angular/forms';


@Component({
    selector: 'app-register-form',
    templateUrl: './register-form.component.html',
    styleUrl: './register-form.component.css',
})
export class RegisterFormComponent {
    membershipId!: string;
    isProfileUpdated: boolean = false;
    isPasswordUpdated: boolean = false;
    profileForm: FormGroup;
    profileError = false;
    passwordError = false; // Flag for displaying error message
    user: any;
    userid: any;
    captchaResponse: string | null = null;

    states = STATES; // List of states for dropdown
    profileData = {
        firstname: '',
        lastname: '',
        companyName: '',
        phone: '',
        email: '',
        addressLine1: '',
        city: '',
        addressLine2: '',
        state: '',
        zipCode: '',
        country: '',
        spouseName: '',
        spouseEmailId: '',
        spousePhoneNumber: '',
        kidsName: '',
        kidDetails: [] as any[],
        aboutMe: '',
        password: '',
        sex: '',
        maritalStatus: '',
        userGotra: '',
        userSubCast: '',
        spouseGotra: '',
        spouseSubCast: '',

        reference1: '',
        reference2: '',
        applicationStatus: '',
        userBriefDesc: '',
        spouseBriefDesc: '',
        chapterAffiliation: '',
        tnc: '',
    };


    chapterList: any;

    constructor(
        private route: ActivatedRoute,
        private userApiService: UserApiService,
        private chapterApiService: ChapterApiService,
        private router: Router,
        private toastr: ToastrService,
        private fb: FormBuilder,
        private spinner: SpinnerService
    ) {
        this.profileForm = this.fb.group(
            {
                firstname: ['', [Validators.required]], // firstname field
                lastname: ['', [Validators.required]],
                companyName: [''],
                phone: ['', [Validators.required]],
                email: ['', [Validators.required]],
                country: ['', [Validators.required]],
                addressLine1: ['', [Validators.required]],
                addressLine2: [''],
                city: ['', [Validators.required]],
                state: ['', [Validators.required]], // Email field
                zipCode: ['', [Validators.required]],
                spouseName: [''],
                spouseEmailId: [''],
                spousePhoneNumber: [''],
                kidsName: [''],
                kidDetails: this.fb.array([]),
                aboutMe: ['', [Validators.required]],
                password: ['', [Validators.required, Validators.minLength(6)]],
                verifypassword: ['', [Validators.required, Validators.minLength(6)]],
                sex: ['', [Validators.required]],
                maritalStatus: ['', [Validators.required]], // Password field
                userGotra: ['', [Validators.required]],
                userSubCast: ['', [Validators.required]],
                chapterAffiliation: ['', [Validators.required]],
                references: this.fb.array([this.createReferenceForm()]),  // at least 1 required
                tnc: [false, [Validators.required]],

            },
            {validators: passwordMatchValidator()}
        );
    }
    createReferenceForm() {
        return this.fb.group({
            name: ['', Validators.required],
            phone: ['', Validators.required],
            chapterAffiliation: ['', '']
        });
    }

    addReference() {
        if (this.references.length < 2) {
            this.references.push(this.createReferenceForm());
        }
    }

    removeReference(index: number) {
        if (this.references.length > 1) {   // enforce at least 1 reference
            this.references.removeAt(index);
        }
    }

    ngOnInit(): void {
        this.membershipId = this.route.snapshot.paramMap.get('id')!;
        // or subscribe for dynamic updates
        this.route.paramMap.subscribe((params) => {
            this.membershipId = params.get('id')!;
        });

        this.spinner.show(); // Show spinner while loading chapters
        this.chapterApiService.getData().pipe(
            finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
        ).subscribe(
            (response) => {

                this.chapterList = response;
                ;
            },
            (error) => {
                // Handle login error (invalid credentials, server error, etc.)
                console.error('Failed to load chapters', error);

            }
        );
    }

    toggleProfileUpdated() {
        this.isProfileUpdated = false;
    }

    createProfile(): void {
        console.log('Profile called');
        if (this.profileForm.valid) {
            this.spinner.show(); // ✅ Show spinner before API call
            this.userApiService.verifyUserEmail(this.profileData).pipe(
                finalize(() => this.spinner.hide()) // ✅ Hide spinner after call completes
            ).subscribe(
                (response) => {
                    if (response === true) {
                        // ✅ Email already registered — stay on same screen
                        this.profileError = true;
                        this.toastr.error(
                            'Email ID is already registered with rajputra.org, Please use another email ID.',
                            'Error'
                        );
                        this.profileForm.markAllAsTouched();
                    } else {
                        // ✅ Email not registered — proceed with registration flow
                        this.profileError = false;
                        this.isProfileUpdated = true;

                        this.profileData.kidDetails = this.kidDetails.value;
                        const refs = this.references.value;

                        const formattedRefs = refs.map((r: any) =>
                            `${r.name} - ${r.phone} - ${r.chapterAffiliation}`
                        );

                        this.profileData['reference1'] = formattedRefs[0] || '';
                        this.profileData['reference2'] = formattedRefs[1] || '';


                        const data = {
                            ...this.profileData,
                            memberType: MembershipType.NON_MEMBER,
                            status: UserStatus.PENDING_PAYMENT,
                            applicationStatus: UserStatus.PENDING_PAYMENT,
                            captcha: this.captchaResponse
                        };

// Save stringified version ONLY for sessionStorage
                        sessionStorage.setItem('pendingRegistration', JSON.stringify(data));
                        // Store the form data in session storage for later use
                        // sessionStorage.setItem('pendingRegistration', data);


                        this.userApiService.registerUser(data).subscribe({
                            next: (resp) => {
                                //  const realUserId = resp.id;
                                sessionStorage.setItem('pendingRegistration', JSON.stringify(resp));
                            },
                            error: (err) => {
                                this.toastr.error(err.error, 'Registration Failed');
                            }
                        });


                        // Navigate to membership selection page
                        this.router.navigate(['/register']);
                    }
                },
                (error) => {
                    // Handle API or network error
                    console.error('User registration failed', error);
                    this.toastr.error(error.error || 'An unexpected error occurred.', 'Submission Failed');
                    this.profileError = true;
                }
            );
        } else {
            this.profileForm.markAllAsTouched();
            this.toastr.error('Please fix the errors in the form.', 'Submission Failed');
        }

    }

    onCaptchaResolved(token: string | null = null
    ) {
        this.captchaResponse = token;
    }

    get firstname() {
        return this.profileForm.get('firstname');
    }

    get lastname() {
        return this.profileForm.get('lastname');
    }

    get companyName() {
        return this.profileForm.get('companyName');
    }

    get phone() {
        return this.profileForm.get('phone');
    }

    get email() {
        return this.profileForm.get('email');
    }

    get addressLine1() {
        return this.profileForm.get('addressLine1');
    }

    get city() {
        return this.profileForm.get('city');
    }

    get addressLine2() {
        return this.profileForm.get('addressLine2');
    }

    get state() {
        return this.profileForm.get('state');
    }
    createKidForm() {
        return this.fb.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            sex: ['', Validators.required],
            yearOfBirth: [''],
            email: ['']
        });
    }
    addKid() {
        this.kidDetails.push(this.createKidForm());
    }

    removeKid(index: number) {
        this.kidDetails.removeAt(index);
    }

    get kidDetails(): FormArray {
        return this.profileForm.get('kidDetails') as FormArray;
    }

    get zipCode() {
        return this.profileForm.get('zipCode');
    }

    get country() {
        return this.profileForm.get('country');
    }

    get password() {
        return this.profileForm.get('password');
    }

    get verifypassword() {
        return this.profileForm.get('verifypassword');
    }

    get spouseName() {
        return this.profileForm.get('spouseName');
    }

    get spouseEmailId() {
        return this.profileForm.get('spouseEmailId');
    }

    get spousePhoneNumber() {
        return this.profileForm.get('spousePhoneNumber');
    }

    get kidsName() {
        return this.profileForm.get('kidsName');
    }

    get aboutMe() {
        return this.profileForm.get('aboutMe');
    }

    get sex() {
        return this.profileForm.get('sex');
    }

    get maritalStatus() {
        return this.profileForm.get('maritalStatus');
    }

    get userGotra() {
        return this.profileForm.get('userGotra');
    }

    get userSubCast() {
        return this.profileForm.get('userSubCast');
    }

    get spouseGotra() {
        return this.profileForm.get('spouseGotra');
    }

    get spouseSubCast() {
        return this.profileForm.get('spouseSubCast');
    }

    get reference1() {
        return this.profileForm.get('reference1');
    }

    get reference2() {
        return this.profileForm.get('reference2');
    }

    get applicationStatus() {
        return this.profileForm.get('applicationStatus');
    }

    get userBriefDesc() {
        return this.profileForm.get('userBriefDesc');
    }

    get spouseBriefDesc() {
        return this.profileForm.get('spouseBriefDesc');
    }

    get chapterAffiliation() {
        return this.profileForm.get('chapterAffiliation');
    }

    get tnc() {
        return this.profileForm.get('tnc');
    }

    get references(): FormArray {
        return this.profileForm.get('references') as FormArray;
    }

}
